import { render, staticRenderFns } from "./ViewOrEditCluster.vue?vue&type=template&id=4fc71ce4&scoped=true&"
import script from "./ViewOrEditCluster.vue?vue&type=script&lang=js&"
export * from "./ViewOrEditCluster.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrEditCluster.vue?vue&type=style&index=0&id=4fc71ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc71ce4",
  null
  
)

export default component.exports